import script from "./AdminGeneral.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminGeneral.vue?vue&type=script&setup=true&lang=ts"

import "./AdminGeneral.vue?vue&type=style&index=0&id=28abd525&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28abd525"]])

export default __exports__